import { useToast } from '@chakra-ui/react'

/**
 * Spread into a mutation's options, Apollo hands `onError` an `ApolloError`, so
 * only `errorMessage` is shown. Pass `onError` the server's message to show it
 * under `errorMessage`, for long enough to read. Likewise, pass `onCompleted`
 * a message to replace `successMessage` (Apollo passes it the mutation data,
 * which is ignored).
 */
export function useToastFeedback(successMessage: string, errorMessage: string) {
    const toast = useToast()

    return {
        onCompleted: (newMessage?: unknown) => {
            const detail =
                typeof newMessage === 'string' && newMessage
                    ? newMessage
                    : undefined

            toast({
                status: 'success',
                duration: detail ? 6000 : 3000,
                description: detail ?? successMessage,
                position: 'top',
            })
        },
        onError: (newMessage?: unknown) => {
            const detail =
                typeof newMessage === 'string' && newMessage
                    ? newMessage
                    : undefined

            toast({
                status: 'error',
                duration: detail ? 6000 : 3000,
                title: detail ? errorMessage : undefined,
                description: detail ?? errorMessage,
                position: 'top',
            })
        },
    }
}

export function useGenericToasts(
    successMessage?: string,
    errorMessage?: string,
) {
    const toast = useToast()

    return {
        onSuccess: (newMessage?: string) => {
            toast({
                status: 'success',
                duration: 3000,
                description: newMessage || successMessage || 'Success!',
            })
        },
        onError: (newMessage?: string) => {
            toast({
                status: 'error',
                duration: 3000,
                description: newMessage || errorMessage || 'Error',
            })
        },
    }
}
